






















































































import { Component, Vue } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { Company, CvType, CvValue, FieldMetadataAccount } from '@/models'
import UpsertAccountFieldModal from '@/components/modals/UpsertAccountFieldModal.vue'

const FIELD_TYPE_CV = 'fmat'

@Component({
  components: { UpsertAccountFieldModal }
})
export default class AccountMetadataFields extends Vue {
  private companies: Company[] = []
  private typeOptions: CvValue[] = []
  private cvTypes: CvType[] = []
  private fields: FieldMetadataAccount[] = []
  private selectedCompanyId = ''
  private selectedField: FieldMetadataAccount | null = null
  private loading = false

  private tableFields = [
    { key: 'fieldCode', label: this.$t('account_metadata_view.columns.field_code'), sortable: true },
    { key: 'label', label: this.$t('account_metadata_view.columns.label'), sortable: true },
    { key: 'typeId', label: this.$t('account_metadata_view.columns.type'), sortable: true },
    { key: 'optionsId', label: this.$t('account_metadata_view.columns.options'), sortable: false },
    { key: 'required', label: this.$t('account_metadata_view.columns.required'), sortable: true, class: 'text-center' },
    { key: 'displayOrder', label: this.$t('account_metadata_view.columns.order'), sortable: true, class: 'text-center' },
    { key: 'actions', label: this.$t('table.actions'), sortable: false, class: 'text-center' }
  ]

  async created() {
    try {
      const [companies, types, cvTypes] = await Promise.all([
        ApiClient.getCompanies(),
        ApiClient.getCvValuesByType(FIELD_TYPE_CV),
        ApiClient.getCvTypes()
      ])
      this.companies = companies
      this.typeOptions = types
      this.cvTypes = cvTypes
    } catch (error) {
      console.error('Error loading account metadata setup:', error)
    }
  }

  typeName(typeId: string): string {
    return this.typeOptions.find(t => t.codeId === typeId)?.name || typeId
  }

  optionsName(optionsId?: string | null): string {
    if (!optionsId) return '-'
    return this.cvTypes.find(t => t.typeId === optionsId)?.name || optionsId
  }

  async loadFields() {
    if (!this.selectedCompanyId) {
      this.fields = []
      return
    }
    try {
      this.loading = true
      this.fields = await ApiClient.getFieldMetadataByCompany(this.selectedCompanyId)
    } catch (error) {
      console.error('Error loading fields:', error)
    } finally {
      this.loading = false
    }
  }

  openCreateModal() {
    this.selectedField = null
    this.$nextTick(() => this.$bvModal.show('UpsertAccountFieldModal'))
  }

  openEditModal(field: FieldMetadataAccount) {
    this.selectedField = { ...field }
    this.$nextTick(() => this.$bvModal.show('UpsertAccountFieldModal'))
  }

  async onFieldSaved() {
    await this.loadFields()
    this.$bvToast.toast(this.$t('account_metadata_view.saved_success').toString(), {
      title: this.$t('feedback.feedback_message_success_title').toString(),
      variant: 'success',
      solid: true,
      autoHideDelay: 2000
    })
  }

  async confirmDelete(field: FieldMetadataAccount) {
    const confirmed = await this.$bvModal.msgBoxConfirm(
      this.$t('account_metadata_view.confirm_delete', { field: field.label || field.fieldCode }).toString(),
      {
        title: this.$t('account_metadata_view.confirm_delete_title').toString(),
        okVariant: 'danger',
        okTitle: this.$t('button_actions.remove').toString(),
        cancelTitle: this.$t('button_actions.cancel').toString(),
        centered: true
      }
    )
    if (!confirmed || !field.id) return

    try {
      await ApiClient.deleteFieldMetadataAccount(field.id)
      await this.loadFields()
      this.$bvToast.toast(this.$t('account_metadata_view.deleted_success').toString(), {
        title: this.$t('feedback.feedback_message_success_title').toString(),
        variant: 'success',
        solid: true
      })
    } catch (error: any) {
      console.error('Error deleting field:', error)
      this.$bvToast.toast(error.message || this.$t('account_metadata_view.error_deleting').toString(), {
        title: this.$t('account_metadata_view.error_title').toString(),
        variant: 'danger',
        solid: true
      })
    }
  }
}
